export default __webpack_public_path__ + "static/media/web.f5b6a3a1.png";